import { render, staticRenderFns } from "./CombosLiquidadosVerificacion.vue?vue&type=template&id=31c89a73&scoped=true"
import script from "./CombosLiquidadosVerificacion.vue?vue&type=script&lang=js"
export * from "./CombosLiquidadosVerificacion.vue?vue&type=script&lang=js"
import style0 from "./CombosLiquidadosVerificacion.vue?vue&type=style&index=0&id=31c89a73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c89a73",
  null
  
)

export default component.exports